export default "__VITE_ASSET__Dr_Z5aIw__"